<script>
export default {
   props: {
    rating: {
      // type: Number,
      required: true
    }
  },
  data() {
    return {
      maxStars: 5,
    }
  },
  methods: {
    getStarClass(starPosition) {
      return starPosition <= this.rating ? 'active-star' : 'star'
    },
  }
}
</script>

<template>
  <div class="stars-rating">
    <span
      v-for="star in maxStars"
      :key="star"
      :class="getStarClass(star)"
    >
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.stars-rating {
  width: 120px;
  height: 24px;
  display: flex;
  flex-direction: row;
}

.star-mixin {
  height: 24px;
  width: 24px;
  background-repeat: no-repeat;
  background-position: center;
}

.active-star {
  @extend .star-mixin;
  background-image: url("../assets/icons/star-active.svg");
}

.star {
  @extend .star-mixin;
  background-image: url("../assets/icons/star.svg");
}
</style>
